import { CircleAlert, CircleCheck, Info, TriangleAlert, type LucideIcon } from 'lucide-react'

export type ToastTone = 'success' | 'info' | 'warning' | 'danger'

export const TOAST_TONES = ['success', 'info', 'warning', 'danger'] as const satisfies ReadonlyArray<ToastTone>

export const TONE_ICONS: Record<ToastTone, LucideIcon> = {
  success: CircleCheck,
  info: Info,
  warning: TriangleAlert,
  danger: CircleAlert,
}

/** The tone lives on the icon only: the surface stays the same dark chrome. */
export const TONE_ICON_COLORS: Record<ToastTone, string> = {
  success: 'text-[var(--success-text-subtle)]',
  info: 'text-[var(--info-text-subtle)]',
  warning: 'text-[var(--warning-text-subtle)]',
  danger: 'text-[var(--danger-text-subtle)]',
}

export function isToastTone(value: string | undefined): value is ToastTone {
  return value !== undefined && value in TONE_ICONS
}
